import {
  Directive,
  effect,
  OnDestroy,
  OnInit,
  Signal,
  TemplateRef,
  inject,
  input,
} from '@angular/core';
import { BehaviorSubject, filter, Observable, Subject, takeUntil } from 'rxjs';
import { TableConstructUIService } from '../services/table-construct.service';
import { RowContextType } from '../models/table-context.model';

@Directive({ selector: '[fr8botUiTableRowDef]' })
export class TableRowDefUIDirective<DataType> implements OnInit, OnDestroy {
  templateRef = inject<TemplateRef<RowContextType<DataType>>>(TemplateRef);
  private tableService = inject<TableConstructUIService<DataType>>(TableConstructUIService);

  readonly fr8botUiTableRowDef = input<DataType>();
  readonly fr8botUiTableRowDefColumns = input<string[]>([]);

  public rowDisplayColumns: Signal<string[]> = this.fr8botUiTableRowDefColumns;

  private _rowIndex = 0;
  private _rowsData$ = new BehaviorSubject<DataType[]>([]);
  private _unsubscribe$ = new Subject<void>();

  public rowsData$: Observable<DataType[]> = this._rowsData$.asObservable();

  constructor() {
    effect(() => {
      const rowDefColumns = this.rowDisplayColumns();
      this.tableService.updateColumnsOrder(rowDefColumns);
    });
  }

  ngOnInit(): void {
    this.initTableDataChangesSubscription();
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
  }

  incrementRowIndex(): void {
    this._rowIndex += 1;
  }

  getRowIndex(): number {
    return this._rowIndex;
  }

  private initTableDataChangesSubscription(): void {
    this.tableService.data$
      .pipe(filter(Boolean), takeUntil(this._unsubscribe$))
      .subscribe((data: DataType[]) => {
        this._rowIndex = 0;
        this._rowsData$.next(data);
      });
  }

  static ngTemplateContextGuard<DataType>(
    dir: TableRowDefUIDirective<DataType>,
    ctx: unknown,
  ): ctx is RowContextType<DataType> {
    return true;
  }
}
